import { render, staticRenderFns } from "./customReplyModal_new.vue?vue&type=template&id=2642a2ff&"
import script from "./customReplyModal_new.vue?vue&type=script&lang=js&"
export * from "./customReplyModal_new.vue?vue&type=script&lang=js&"
import style0 from "./customReplyModal_new.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports